export default (process.env.NODE_ENV === 'production' ||
    process.env.NODE_ENV === 'test'
  ? require('./config.production').default
  : require('./config.local').default);
